import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useBody } from "../../invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Rept } from "../../../../Context/InshData";
import TotalsInvCom from "../../AFReadyDisigen/A4/TotalsInvCom";
const BodyInv = (props) => {
  const cls = useRptAF();
  //   const { onUnmountComplete, data } = props;
  const { onUnmountComplete, data, isFullPage, isLast, inv, sta, locInv, found } = props;

  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  const clas = useInvAF();
  const calssBody = useBody();
  //   const islast=(data?.length )

  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: "No \n م", field: "no" },
    // { title:premiApp.billTemplate !== 9?"Barcode \n الباركود":"No Item \n الرقم", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
    {
      title: "Price \n السعر ",
      field: "new_exchange_price",

    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    // { title: txtA.taxableAmount, field: "totBill" },
    { title: "Unit \n الوحدة", field: "unit_name", },

    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },

    // { title: txtA.taxRate, field: "taxperc" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const data2 = data.map((row, i) => {
    return {
      ...row,
      id: i + 1,
      totBill: row.totBill.toFixed(2),
      new_exchange_price: row.exchange_price.toFixed(locInv?.NRound ?? 4),
      tot_net_curr: row.tot_net_curr.toFixed(2),
      discount: row.discount.toFixed(2),
    };
  });
  const data3 = data.map((row, i) => {
    return {
      ...row,
      id: i + 1,
      totBill: row.totBill.toFixed(2),
      new_exchange_price: row.exchange_price.toFixed(2),
      tot_net_curr: row.tot_net_curr.toFixed(2),
      discount: row.discount.toFixed(2),
    };
  });

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: premiApp.billTemplate === 27 ? "ltr" : "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
          style={{
          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={columns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))}
            data={premiApp.billTemplate !== 9 ? data2 : data3}
          />
          {premiApp.billTemplate !== 27 &&
            (
              <Grid item xs={12} className={clas.BdytotCntMmm} style={{ textAlign: "right" }}>
                {inv.notes}
              </Grid>
            )}
          {premiApp.billTemplate === 27 ?
            (isLast && <TotalsInvCom found={found} inv={inv} sta={sta} />) :
            (isLast && <InvTotal inv={inv} sta={sta} />)}
        </Grid>
      </Grid>

    </Grid>
  );
};

export default BodyInv;
